export default __webpack_public_path__ + "static/media/settingsIcon.f3f15426.svg";